import { render, staticRenderFns } from "./ModalDialog.vue?vue&type=template&id=55643cd2"
import script from "./ModalDialog.vue?vue&type=script&lang=js"
export * from "./ModalDialog.vue?vue&type=script&lang=js"
import style0 from "./ModalDialog.vue?vue&type=style&index=0&id=55643cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports